// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5938":"67bb8438","9905":"67bb8438"}[chunkId] + ".chunk.css";
};